import styled from 'styled-components'

const SolutionStyle = styled.div`
	--solDescWrapMarTB: var(--sp16x);

	.section {
		margin-bottom: 0;
	}

	.solDescWrap {
		margin-top: var(--solDescWrapMarTB);
		margin-bottom: var(--solDescWrapMarTB);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--solDescWrapMarTB: var(--sp13x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--solDescWrapMarTB: var(--sp11x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--solDescWrapMarTB: var(--sp10x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--solDescWrapMarTB: var(--sp10x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--solDescWrapMarTB: var(--sp9x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--solDescWrapMarTB: var(--sp9x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--solDescWrapMarTB: var(--sp8x);
	}
`

export default SolutionStyle
